import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as addressReducer from '../../reducers/addressReducer';
import { getLocalProps, setLocalProps } from '../../helpers/localStorage';
import * as modal from '../../reducers/modalReducer';

class ArrowBackBtn extends Component {
  getBorderStyle = () => {
    return this.props.borderWeight ? [this.props.borderWeight, 'px', ' solid #', this.props.color].join('') : ['3px', ' solid #', this.props.color].join('');
  }

  render() {
    const style = {
      border: this.getBorderStyle(),
      borderRadius: '30px',
      height: '27px',
      width: '27px',
      lineHeight: '27px',
      textAlign: 'center'
    }
    return (
      <div style={style}><i style={{color:'#'+this.props.color }} className="material-icons">arrow_back</i></div>
    )
  }
}
 
export default ArrowBackBtn;



// WEBPACK FOOTER //
// ./src/components/ArrowBackBtn/ArrowBackBtn.jsx